import { render } from "./DS.vue?vue&type=template&id=3e5a0ef2&scoped=true&ts=true"
import script from "./DS.vue?vue&type=script&lang=ts"
export * from "./DS.vue?vue&type=script&lang=ts"

import "./DS.vue?vue&type=style&index=0&id=3e5a0ef2&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e5a0ef2"]])

export default __exports__